import { createReducer } from '@zapier/toolbox-redux-framework';

const initialState = {};
const handlers = {};

export default createReducer(handlers, initialState);
